import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { convertImageUrl_S_to_M } from '~/backend/helper';
import ProductStatuses from '~/components/product/productPage/ProductStatuses';
import ProductCardPrice from './ProductCardLargePrice';

const ProductCardImage = ({ handledProduct }) => {
	const { t } = useTranslation();

	return (
		<div className="img-container">
			<img src={convertImageUrl_S_to_M(handledProduct.image)} alt="Product" loading="lazy" />
			<div className="tags-prices">
				<ProductStatuses product={handledProduct} statuses={handledProduct.statuses} />
				<ProductCardPrice handledProduct={handledProduct} />
			</div>
		</div>
	);
};

ProductCardImage.propTypes = {
	handledProduct: PropTypes.object
};

export default ProductCardImage;
